import { makeStyles, tokens } from '@fluentui/react-components';

export const useCandidateDetailsPanelStyles = makeStyles({
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        paddingBottom: '24px',
    },
    infoSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        margin: '0',
        padding: '0',
    },
    infoRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    label: {
        fontSize: '12px',
        fontWeight: '600',
        color: tokens.colorNeutralForeground1,
    },
    value: {
        fontSize: '14px',
        color: tokens.colorNeutralForeground1,
        margin: '0',
    },
    emailContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        margin: '0',
    },
    stepsSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    stepsTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: tokens.colorNeutralForeground1,
        margin: '0',
    },
    accordionHeader: {
        fontSize: '14px',
    },
    accordionPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        paddingLeft: '8px',
    },
    stepRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px',
        paddingTop: '8px',
        paddingBottom: '8px',
    },
    stepInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    stepName: {
        fontSize: '14px',
        color: tokens.colorNeutralForeground1,
    },
    stepDate: {
        fontSize: '12px',
        color: tokens.colorNeutralForeground2,
    },
    dateRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    statusBadge: {
        flexShrink: 0,
    },
    needHelpSection: {
        marginTop: '24px',
        paddingTop: '16px',
        borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    needHelpTitle: {
        fontSize: '16px',
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        margin: 0,
    },
    needHelpText: {
        fontSize: '14px',
        color: tokens.colorNeutralForeground1,
    },
    needHelpLink: {
        color: tokens.colorBrandForegroundLink,
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline',
        },
    },
    needHelpHint: {
        fontSize: '13px',
        color: tokens.colorNeutralForeground2,
    },
    footer: {
        marginTop: 'auto',
        paddingTop: '16px',
        borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    },
});
